import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {BillingRequest} from '../../models/accounting/billing-request';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class BillingRequestService extends AbstractModelService<BillingRequest> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/billing-request', BillingRequest);
  }

  recalculate(id: number): Observable<{ invoiced: boolean, reference: string | null }> {
    return new Observable<{ invoiced: boolean, reference: string | null }>((subscriber: Subscriber<{ invoiced: boolean, reference: string | null }>): void => {
      this.apiClient.post(this.routePath + '/' + id + '/recalculate').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
